import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, vModelText as _vModelText } from "vue"

const _hoisted_1 = { style: {"width":"20%"} }
const _hoisted_2 = ["value"]
const _hoisted_3 = ["value"]
const _hoisted_4 = ["value"]
const _hoisted_5 = { style: {"position":"relative","width":"30%"} }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { class: "icon" }
const _hoisted_9 = ["src", "alt"]
const _hoisted_10 = { class: "tooltip" }
const _hoisted_11 = { style: {"width":"20%"} }
const _hoisted_12 = ["value"]
const _hoisted_13 = ["value"]
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "talent-and-artifact" }
const _hoisted_16 = { class: "icon" }
const _hoisted_17 = ["src", "alt"]
const _hoisted_18 = { class: "tooltip" }
const _hoisted_19 = { class: "icon" }
const _hoisted_20 = ["src", "alt"]
const _hoisted_21 = { class: "tooltip" }
const _hoisted_22 = { class: "icon" }
const _hoisted_23 = ["src", "alt"]
const _hoisted_24 = { class: "tooltip" }
const _hoisted_25 = { class: "icon" }
const _hoisted_26 = ["src", "alt"]
const _hoisted_27 = { class: "tooltip" }
const _hoisted_28 = { class: "icon" }
const _hoisted_29 = ["src", "alt"]
const _hoisted_30 = { class: "tooltip" }
const _hoisted_31 = { class: "artifact-detail-button icon" }
const _hoisted_32 = ["src", "alt"]
const _hoisted_33 = { class: "artifact-score" }
const _hoisted_34 = { class: "tooltip" }
const _hoisted_35 = ["value"]
const _hoisted_36 = ["value"]
const _hoisted_37 = ["value"]
const _hoisted_38 = { style: {"table-layout":"fixed"} }
const _hoisted_39 = { colspan: "3" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = ["disabled"]
const _hoisted_42 = { colspan: "6" }
const _hoisted_43 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("table", null, [
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", {
            class: _normalizeClass('name ' + _ctx.colorClass(_ctx.characterMaster)),
            colspan: "2"
          }, [
            _createElementVNode("span", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('open:character-info', 1)))
            }, [
              _createTextVNode(_toDisplayString(_ctx.displayName(_ctx.characterMaster.名前)) + " ", 1),
              _cache[32] || (_cache[32] = _createElementVNode("span", { class: "material-symbols-outlined" }, " info ", -1))
            ])
          ], 2),
          _createElementVNode("td", {
            colspan: "2",
            class: _normalizeClass('title ' + _ctx.colorClass(_ctx.characterMaster))
          }, [
            _withDirectives(_createElementVNode("span", null, _toDisplayString(_ctx.displayName(_ctx.characterMaster.baseInfo.称号)), 513), [
              [_vShow, _ctx.characterMaster.baseInfo.称号]
            ])
          ], 2)
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_1, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.characterInputRea.突破レベル) = $event)),
              onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.ascensionOnChange && _ctx.ascensionOnChange(...args)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ascensionRange, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: item,
                  key: item
                }, " A" + _toDisplayString(item), 9, _hoisted_2))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.characterInputRea.突破レベル]
            ]),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.characterInputRea.レベル) = $event)),
              onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.characterOnChange && _ctx.characterOnChange(...args)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.levelRange, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: item,
                  key: item
                }, " Lv." + _toDisplayString(item), 9, _hoisted_3))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.characterInputRea.レベル]
            ]),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.characterInputRea.命ノ星座) = $event)),
              onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.characterOnChange && _ctx.characterOnChange(...args)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.constellationRange, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: item,
                  key: item
                }, " C" + _toDisplayString(item), 9, _hoisted_4))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.characterInputRea.命ノ星座]
            ])
          ]),
          _createElementVNode("td", _hoisted_5, [
            _createElementVNode("img", {
              class: _normalizeClass('character' + _ctx.bgImageClass(_ctx.characterMaster)),
              src: _ctx.characterMaster.icon_url,
              alt: _ctx.characterMaster.名前,
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('open:character-select')))
            }, null, 10, _hoisted_6),
            _createElementVNode("img", {
              class: "vision",
              src: _ctx.visionSrc(_ctx.characterMaster),
              alt: _ctx.characterMaster.元素
            }, null, 8, _hoisted_7)
          ]),
          _createElementVNode("td", _hoisted_8, [
            _createElementVNode("img", {
              class: _normalizeClass('weapon' + _ctx.bgImageClass(_ctx.weaponMaster)),
              src: _ctx.weaponMaster['icon_url'],
              alt: _ctx.weaponMaster.名前,
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('open:weapon-select')))
            }, null, 10, _hoisted_9),
            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.displayName(_ctx.weaponMaster.名前)), 1)
          ]),
          _createElementVNode("td", _hoisted_11, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.characterInputRea.武器突破レベル) = $event)),
              onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.weaponAscensionOnChange && _ctx.weaponAscensionOnChange(...args)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weaponAscensionRange, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: item,
                  key: item
                }, " A" + _toDisplayString(item), 9, _hoisted_12))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.characterInputRea.武器突破レベル]
            ]),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.characterInputRea.武器レベル) = $event)),
              onChange: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.weaponOnChange && _ctx.weaponOnChange(...args)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weaponLevelRange, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: item,
                  key: item
                }, " Lv." + _toDisplayString(item), 9, _hoisted_13))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.characterInputRea.武器レベル]
            ]),
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.characterInputRea.武器精錬ランク) = $event)),
              onChange: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.weaponOnChange && _ctx.weaponOnChange(...args)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weaponRefineRange, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: item,
                  key: item
                }, " R" + _toDisplayString(item), 9, _hoisted_14))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.characterInputRea.武器精錬ランク]
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("table", _hoisted_15, [
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_16, [
            _createElementVNode("img", {
              class: _normalizeClass('talent ' + _ctx.bgColorClass(_ctx.characterMaster)),
              src: _ctx.characterMaster['通常攻撃']['icon_url'],
              alt: _ctx.characterMaster['通常攻撃']['名前'],
              onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('open:character-info', 2)))
            }, null, 10, _hoisted_17),
            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.displayName(_ctx.characterMaster["通常攻撃"]["名前"])), 1)
          ]),
          _createElementVNode("td", _hoisted_19, [
            _createElementVNode("img", {
              class: _normalizeClass('talent ' + _ctx.bgColorClass(_ctx.characterMaster)),
              src: _ctx.characterMaster['元素スキル']['icon_url'],
              alt: _ctx.characterMaster['元素スキル']['名前'],
              onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.$emit('open:character-info', 3)))
            }, null, 10, _hoisted_20),
            _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.displayName(_ctx.characterMaster["元素スキル"]["名前"])), 1)
          ]),
          _createElementVNode("td", _hoisted_22, [
            _createElementVNode("img", {
              class: _normalizeClass('talent ' + _ctx.bgColorClass(_ctx.characterMaster)),
              src: _ctx.characterMaster['元素爆発']['icon_url'],
              alt: _ctx.characterMaster['元素爆発']['名前'],
              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.$emit('open:character-info', 4)))
            }, null, 10, _hoisted_23),
            _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.displayName(_ctx.characterMaster["元素爆発"]["名前"])), 1)
          ]),
          _createElementVNode("td", _hoisted_25, [
            _createElementVNode("label", {
              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.openArtifactSetSelect(0)))
            }, [
              _createElementVNode("img", {
                class: _normalizeClass('artifact-set' + _ctx.artifactSetSelectClass(0)),
                src: _ctx.getArtifactIconUrl(_ctx.artifactSetMasters[0].key),
                alt: _ctx.artifactSetMasters[0].key
              }, null, 10, _hoisted_26)
            ]),
            _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.displayName(_ctx.artifactSetMasters[0].key)), 1)
          ]),
          _createElementVNode("td", _hoisted_28, [
            _createElementVNode("label", {
              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.openArtifactSetSelect(1)))
            }, [
              _createElementVNode("img", {
                class: _normalizeClass('artifact-set' + _ctx.artifactSetSelectClass(1)),
                src: _ctx.getArtifactIconUrl(_ctx.artifactSetMasters[1].key),
                alt: _ctx.artifactSetMasters[1].key
              }, null, 10, _hoisted_29)
            ]),
            _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.displayName(_ctx.artifactSetMasters[1].key)), 1)
          ]),
          _createElementVNode("td", _hoisted_31, [
            _createElementVNode("label", {
              onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.$emit('open:artifact-detail-input')))
            }, [
              _createElementVNode("img", {
                class: "artifact-set",
                src: _ctx.IMG_SRC_DUMMY,
                alt: _ctx.displayName('聖遺物ステータス')
              }, null, 8, _hoisted_32),
              _cache[35] || (_cache[35] = _createElementVNode("img", {
                class: "left-icon",
                src: "images/artifact.png",
                alt: "artifact"
              }, null, -1)),
              _cache[36] || (_cache[36] = _createElementVNode("img", {
                class: "right-icon",
                src: "images/artifact.png",
                alt: "artifact"
              }, null, -1)),
              _createElementVNode("div", _hoisted_33, [
                _cache[33] || (_cache[33] = _createTextVNode(" score ")),
                _cache[34] || (_cache[34] = _createElementVNode("br", null, null, -1)),
                _createTextVNode(" " + _toDisplayString(Math.round(_ctx.artifactScore * 10) / 10), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.displayName("聖遺物詳細")), 1)
          ])
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.characterInputRea.通常攻撃レベル) = $event)),
              onChange: _cache[22] || (_cache[22] = 
//@ts-ignore
(...args) => (_ctx.characterOnChange && _ctx.characterOnChange(...args)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.normalAttackLevelRange, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: item,
                  key: item
                }, " Lv." + _toDisplayString(item), 9, _hoisted_35))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.characterInputRea.通常攻撃レベル]
            ])
          ]),
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.characterInputRea.元素スキルレベル) = $event)),
              onChange: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.characterOnChange && _ctx.characterOnChange(...args)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.elementalSkillLevelRange, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: item,
                  key: item
                }, " Lv." + _toDisplayString(item), 9, _hoisted_36))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.characterInputRea.元素スキルレベル]
            ])
          ]),
          _createElementVNode("td", null, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.characterInputRea.元素爆発レベル) = $event)),
              onChange: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.characterOnChange && _ctx.characterOnChange(...args)))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.elementalBurstLevelRange, (item) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: item,
                  key: item
                }, " Lv." + _toDisplayString(item), 9, _hoisted_37))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.characterInputRea.元素爆発レベル]
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("table", _hoisted_38, [
      _createElementVNode("tbody", null, [
        _createElementVNode("tr", null, [
          _cache[37] || (_cache[37] = _createElementVNode("td", null, "buildname", -1)),
          _createElementVNode("td", _hoisted_39, [
            _withDirectives(_createElementVNode("input", {
              class: "save-name",
              type: "text",
              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.characterInputRea.buildname) = $event)),
              maxlength: "20",
              placeholder: "input build name"
            }, null, 512), [
              [_vModelText, _ctx.characterInputRea.buildname]
            ])
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("button", {
              type: "button",
              disabled: _ctx.saveDisabled,
              onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.saveOnClick && _ctx.saveOnClick(...args)))
            }, " Save ", 8, _hoisted_40)
          ]),
          _createElementVNode("td", null, [
            _createElementVNode("button", {
              type: "button",
              disabled: _ctx.characterInputRea.removeDisabled,
              onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.removeOnClick && _ctx.removeOnClick(...args)))
            }, " Remove ", 8, _hoisted_41)
          ])
        ]),
        _createElementVNode("tr", null, [
          _createElementVNode("td", _hoisted_42, [
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.characterInputRea.recommendationSelectedIndex) = $event)),
              onChange: _cache[31] || (_cache[31] = ($event: any) => (_ctx.recommendationOnChange(_ctx.targetValue($event)))),
              placeholder: "select preset or saved build"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recommendationList, (item, index) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: index,
                  key: index
                }, _toDisplayString(_ctx.displayBuildName(item)), 9, _hoisted_43))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.characterInputRea.recommendationSelectedIndex]
            ])
          ])
        ])
      ])
    ])
  ], 64))
}